export default __webpack_public_path__ + "static/media/login-center.5c0dcc5d.png";